const FACEBOOK = 'socialmediaplannerfacebookpost';
const INSTAGRAM = 'socialmediaplannerinstagrampost';
const PINTEREST = 'socialmediaplannerpinterestpin';
const TWITTER = 'socialmediaplannertwittertweet';
const LINKEDIN = 'socialmediaplannerlinkedinpost';
const TIKTOK = 'socialmediaplannertiktokpost';
const THREADS = 'socialmediaplannerthreadsthread';
const YT_SHORTS = 'socialmediaplanneryoutubeshort';

export default {
  FACEBOOK,
  INSTAGRAM,
  PINTEREST,
  TWITTER,
  LINKEDIN,
  TIKTOK,
  THREADS,
  YT_SHORTS,
};
